
import { Card } from "@/components/ui/card";
import { LLMInsights } from "../LLMInsights";
import { Industry, OrganizationSize } from "@/types/assessment";

interface AIMAAInsightsProps {
  assessmentId: string;
  assessmentData: {
    organizationDetails: {
      industry: Industry;
      size: OrganizationSize;
    };
    dimensionScores: Record<string, number>;
  };
}

export const AIMAAInsights = ({ assessmentId, assessmentData }: AIMAAInsightsProps) => {
  return (
    <Card className="p-6">
      <h2 className="text-2xl font-bold text-primary mb-6">AIMAA Assessment Insights</h2>
      <LLMInsights 
        assessmentId={assessmentId} 
        assessmentData={assessmentData}
      />
    </Card>
  );
};
